import { Empty, Button } from 'antd';
import { useHistory } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons';
import styled from 'styled-components';

// locales
import { txt } from '../../locales/i18n';

export function NotFoundRoute(): JSX.Element {
	const history = useHistory();

	return (
		<Container>
			<Empty description={txt('navigation.not found message')} />
			<Button onClick={history.goBack}>
				<ArrowLeftOutlined />
				{txt('navigation.go back')}
			</Button>
		</Container>
	);
}

const Container = styled.main`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 2rem;
`;
